<div fxLayout="column">
  <app-page-header [section]="'Transaction Schedule'"
                   [title]="'Keep an eye on transactions'"
                   [description]="'View a daily summary of your tenants’ sales and the fees applied to them, giving you a clear and up-to-date overview.'"></app-page-header>

    <div class="page-content page-padding full-screen-height-page-default" fxLayout="column">
    <span class="subtitle-default">Daily Transaction Summary</span>
    <form fxLayout="row" fxLayoutAlign="start center" fxFlexOffset="20px"
          [formGroup]="filterForm">
      <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always">
        <mat-label>Company Name</mat-label>
        <input [disabled]="!!(loader.loading$ | async)" matInput type="text" placeholder="Search here"
               formControlName="companyName">
      </mat-form-field>

      <span class="fx-spacer"></span>

      <app-custom-date-filter [customDateRangePresets]="dateFilters" (dateRange)="getDateRange($event)"></app-custom-date-filter>

      <button mat-icon-button color="primary" [disabled]="!!(loader.loading$ | async)" (click)="filterData()"
              matTooltip="Filter data">
        <mat-icon color="primary">filter_alt</mat-icon>
      </button>

      <button
        mat-icon-button
        [matMenuTriggerFor]="mainOptionsMenu"
        matTooltip="Download data"
        [disabled]="!!(loader.loading$ | async)"
      >
        <mat-icon class="crud-table-main-toolbar-icon">download</mat-icon>
      </button>
      <mat-menu #mainOptionsMenu="matMenu">
        <!-- Export to CSV -->
        <button mat-menu-item (click)="exportToCsv()">
          <mat-icon>file_download</mat-icon>
          <span>Export to CSV</span>
        </button>

        <!-- Export to Excel -->
        <button mat-menu-item (click)="exportToExcel()">
          <mat-icon>file_download</mat-icon>
          <span>Export to Excel</span>
        </button>

        <!-- Export to PDF -->
        <button mat-menu-item (click)="exportToPdf()">
          <mat-icon>file_download</mat-icon>
          <span>Export to PDF</span>
        </button>

      </mat-menu>
    </form>

    <div class="transaction-summary-chart-container">
      <canvas baseChart

              [data]="chartData"
              [options]="chartOptions"
              [type]="'line'"></canvas>
    </div>


    <div class="mat-elevation-z3 radius-10 bg-white" fxLayout="column" fxFlexOffset="30px">
        <table mat-table class="custom-table chart-table" [dataSource]="dataSource">
          <ng-container matColumnDef="table-label">
            <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="displayedColumns.length"> Daily Transaction Summary </th>
          </ng-container>

          <ng-container matColumnDef="retailerCompanyName">
            <th mat-header-cell *matHeaderCellDef> Retailer </th>
            <td mat-cell class="custom-table-cell btn-cursor" *matCellDef="let element"> {{ utils.displayString(element.retailerCompanyName, 20) }} </td>
            <td mat-footer-cell *matFooterCellDef><span class="heading-default"><strong>Totals:</strong></span></td>

          </ng-container>

          <ng-container matColumnDef="transactionDate">
            <th mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell class="custom-table-cell"
                *matCellDef="let element"> {{ dateUtils.displayDateWithTime(element.transactionDate) }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>

          </ng-container>

          <ng-container matColumnDef="saleAmountIncl">
            <th mat-header-cell *matHeaderCellDef> Total Sales </th>
            <td mat-cell class="custom-table-cell"
                *matCellDef="let element"> {{ utils.displayRandAmountWithDecimal(element.saleAmountIncl) }}
            </td>
            <td mat-footer-cell
                *matFooterCellDef><span
              [ngClass]="{'long-total': this.hasLongTotals}"
              class="heading-default">
              {{ summaryTotals.saleAmountIncl.displayedValue }}
            </span>
            </td>
          </ng-container>


          <ng-container matColumnDef="paymentsExternalIncl">
            <th mat-header-cell *matHeaderCellDef> External Payments </th>
            <td mat-cell class="custom-table-cell btn-cursor"
                *matCellDef="let element">{{ utils.displayRandAmountWithDecimal(element.paymentsExternalIncl) }}
            </td>
            <td mat-footer-cell
                *matFooterCellDef><span
              [ngClass]="{'long-total': this.hasLongTotals}"
              class="heading-default">
              {{ summaryTotals.paymentsExternalIncl.displayedValue }}</span>
            </td>

          </ng-container>

          <ng-container matColumnDef="paymentsCollectedIncl">
            <th mat-header-cell *matHeaderCellDef> Internal Payments </th>
            <td mat-cell class="custom-table-cell btn-cursor"
                *matCellDef="let element">{{ utils.displayRandAmountWithDecimal(element.paymentsCollectedIncl) }}
            </td>
            <td mat-footer-cell
                *matFooterCellDef><span
              [ngClass]="{'long-total': this.hasLongTotals}"
              class="heading-default">
              {{ summaryTotals.paymentsCollectedIncl.displayedValue }}</span>
            </td>

          </ng-container>

          <ng-container matColumnDef="transactionFeeIncl">
            <th mat-header-cell *matHeaderCellDef> Transaction Fee </th>
            <td mat-cell class="custom-table-cell btn-cursor"
                *matCellDef="let element">{{ utils.displayRandAmountWithDecimal(element.transactionFeeIncl) }}
            </td>
            <td mat-footer-cell
                *matFooterCellDef><span
              [ngClass]="{'long-total': this.hasLongTotals}"
              class="heading-default">
              {{ summaryTotals.transactionFeeIncl.displayedValue }}</span>
            </td>

          </ng-container>

          <ng-container matColumnDef="turnoverRentalFeeIncl">
            <th mat-header-cell *matHeaderCellDef> Rental Fee </th>
            <td mat-cell class="custom-table-cell btn-cursor"
                *matCellDef="let element">{{ utils.displayRandAmountWithDecimal(element.turnoverRentalFeeIncl) }}
            </td>
            <td mat-footer-cell
                *matFooterCellDef>
              <span [ngClass]="{'long-total': this.hasLongTotals}"
                    class="heading-default">
                {{ summaryTotals.turnoverRentalFeeIncl.displayedValue }}</span>
            </td>

          </ng-container>

          <ng-container matColumnDef="netBalancePayableRetailerInclRounded">
            <th mat-header-cell *matHeaderCellDef> Payable balance</th>
            <td mat-cell class="custom-table-cell btn-cursor"
                *matCellDef="let element"> {{ utils.displayRandAmountWithDecimal(element.netBalancePayableRetailerInclRounded) }}
            </td>
            <td mat-footer-cell
                *matFooterCellDef>
              <span [ngClass]="{'long-total': this.hasLongTotals}"
                    class="heading-default">
              {{ summaryTotals.netBalancePayableRetailerInclRounded.displayedValue }}
            </span></td>
          </ng-container>

          <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
          <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      <mat-paginator #paginator class="custom-paginator"
                     [length]="dataSourceLength"
                     [disabled]="!!(loader.loading$ | async)"
                     [pageSize]="10"></mat-paginator>
    </div>
    <div class="info-card-dark" fxLayout="column" fxLayoutGap="20px" fxFlexOffset="30px">
      <span class="heading-bold">Notes</span>
      <span class="body-1-regular-2">Totals are for all the data returned not just the current page</span>
    </div>
  </div>
</div>
